import React from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineArrowBackIos } from 'react-icons/md';
import { IconContext } from 'react-icons';

const ReturnButton = () => {
    return (
        <div className=' absolute inline m-2'>
            <Link to='/'>
                <IconContext.Provider
                    value={{
                        color: 'silver',
                        className: 'my-auto w-8 h-8 ',
                    }}
                >
                    <MdOutlineArrowBackIos />
                </IconContext.Provider>
            </Link>
        </div>
    );
};

export default ReturnButton;
